import { render, staticRenderFns } from "./ShowErrors.vue?vue&type=template&id=51bc0bb5&"
import script from "./ShowErrors.vue?vue&type=script&lang=js&"
export * from "./ShowErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports